<template>
  <router-view :defaultHeader="defaultHeader"></router-view>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TenancyPaymentsView',
  props: {
    defaultHeader: {
      type: String,
      required: true,
    },
  },
});
</script>
